var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page container"},[_c('div',[_c('activity',{attrs:{"isCreate":true,"type":_vm.getType,"lessonId":_vm.getLessonId,"cancelRoute":_vm.getLessonRoute,"successRoute":_vm.getLessonRoute}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }